var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLine3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 2,
    viewBox: "0 0 43 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_636)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1L43 1",
    stroke: "url(#paint0_linear_261_636)",
    strokeWidth: 2,
    strokeDasharray: "6 6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_261_636",
    x1: 8.5,
    y1: 1,
    x2: 38.5,
    y2: 1.00002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAC3DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96DBB6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine3);
export default __webpack_public_path__ + "static/media/line3.fc97ca91d8e68663a397215b13529b87.svg";
export { ForwardRef as ReactComponent };